<template>
    <div v-if="visibleWidgetCount > 0" class="grid grid-cols-1 gap-5" :class="gridClass">
        <div v-if="showTicketsWidget" class="bg-white overflow-hidden shadow rounded-sm flex flex-col">
            <loading :status="stats.open_tickets == null"/>
            <div class="px-4 py-5 sm:p-6 flex-1">
                <dt class="text-sm font-medium text-gray-500 truncate">
                    {{ $t('Open tickets') }}
                </dt>
                <dd class="mt-1 text-3xl font-semibold text-gray-900">
                    {{ stats.open_tickets ? stats.open_tickets : 0 }}
                </dd>
            </div>
            <router-link
                class="px-4 py-2 border-t border-bordergray-100 flex items-center justify-between text-xs text-gray-500 hover:text-gray-700"
                :to="ticketOverviewRoute"
            >
                <span>{{ $t('Ticket overview') }}</span>
                <svg-vue class="h-4 w-4 text-gray-700" icon="font-awesome.chevron-right-solid"></svg-vue>
            </router-link>
        </div>
        <div v-if="showPositionsWidget" class="bg-white overflow-hidden shadow rounded-sm flex flex-col">
            <loading :status="stats.open_positions == null"/>
            <div class="px-4 py-5 sm:p-6 flex-1">
                <dt class="text-sm font-medium text-gray-500 truncate">
                    {{ $t('Open positions') }}
                </dt>
                <dd class="mt-1 text-3xl font-semibold text-gray-900">
                    {{ stats.open_positions ? stats.open_positions : 0 }}
                </dd>
            </div>
            <router-link
                class="px-4 py-2 border-t border-bordergray-100 flex items-center justify-between text-xs text-gray-500 hover:text-gray-700"
                :to="positionOverviewRoute"
            >
                <span>{{ $t('Position overview') }}</span>
                <svg-vue class="h-4 w-4 text-gray-700" icon="font-awesome.chevron-right-solid"></svg-vue>
            </router-link>
        </div>
        <div v-if="showFilesWidget" class="bg-white overflow-hidden shadow rounded-sm flex flex-col">
            <loading :status="stats.uploaded_files == null"/>
            <div class="px-4 py-5 sm:p-6 flex-1">
                <dt class="text-sm font-medium text-gray-500 truncate">
                    {{ fileCardTitle }}
                </dt>
                <dd class="mt-1 text-3xl font-semibold text-gray-900">
                    {{ stats.uploaded_files ? stats.uploaded_files : 0 }}
                </dd>
            </div>
            <router-link
                :to="fileOverviewRoute"
                class="px-4 py-2 border-t border-bordergray-100 flex items-center justify-between text-xs text-gray-500 hover:text-gray-700"
            >
                <span>{{ fileOverviewLabel }}</span>
                <svg-vue class="h-4 w-4 text-gray-700" icon="font-awesome.chevron-right-solid"></svg-vue>
            </router-link>
        </div>
    </div>
</template>

<script>
import {resolveStoreAccess} from "@/utils/access-context";

export default {
    name: "stats",
    computed: {
        accessContext() {
            return resolveStoreAccess(this.$store);
        },
        showTicketsWidget() {
            return !!this.accessContext.modules.tickets;
        },
        showPositionsWidget() {
            return !!this.accessContext.modules.positions;
        },
        showFilesWidget() {
            return !!this.accessContext.modules.file_manager;
        },
        visibleWidgetCount() {
            return [this.showTicketsWidget, this.showPositionsWidget, this.showFilesWidget]
                .filter((isVisible) => isVisible).length;
        },
        gridClass() {
            if (this.visibleWidgetCount === 3) {
                return 'sm:grid-cols-2 xl:grid-cols-3';
            }

            if (this.visibleWidgetCount === 2) {
                return 'sm:grid-cols-2';
            }

            return 'sm:grid-cols-1';
        },
        ticketOverviewRoute() {
            return this.accessContext.template_family === 'customer'
                ? '/tickets/list'
                : '/workspace/tickets';
        },
        positionOverviewRoute() {
            return this.accessContext.template_family === 'customer'
                ? '/positions/list'
                : '/workspace/positions';
        },
        fileOverviewRoute() {
            return this.accessContext.template_family === 'customer'
                ? '/file-manager/list'
                : {path: '/workspace/file-manager', query: {scope: 'own'}};
        },
        fileCardTitle() {
            return this.accessContext.template_family === 'customer'
                ? 'Dateien'
                : this.$t('Uploaded files');
        },
        fileOverviewLabel() {
            return this.accessContext.template_family === 'customer'
                ? 'Dateimanager'
                : this.$t('My files');
        },
    },
    data() {
        return {
            stats: {
                open_tickets: null,
                open_positions: null,
                uploaded_files: null,
            }
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            const self = this;
            axios.get('api/workspace/stats/count').then(function (response) {
                self.stats = response.data;
            });
        },
    },
}
</script>
